import React from 'react';
import { Translation, withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { mapStateToProps } from 'root/redux/selector/selector';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import SVGElements from 'root/components/SVGElements';
import classnames from 'classnames';
import MaintenanceModalV2 from '../../../../components/Modal/MaintenanceModalV2';
import SVG from 'react-inlinesvg';

class BrandList extends React.Component {
    isMount = true;
    constructor(props) {
        super(props);

        this.state = { isUnderMaintenance: false, providerName: '', maintenanceDetails: {} };
    }

    handle(item) {
        const tag = item.provider;
        const name = item.name;
        const route = item.route;

        if (item.underMaintenance) {
            this.setState({ isUnderMaintenance: true, maintenanceDetails: item.underMaintenance, providerName: name });
        } else {
            this.props.onBrandChange(tag, name, route);
        }
    }

    handleClose = () => {
        this.setState({ isUnderMaintenance: false, maintenanceDetails: {} });
    };

    componentDidUpdate() {
        if (this.props.slotsFunction.provider === 'UL' && !this.props.slotsFunction.isLoading) {
            this.props.history.push('/ultimate-slots');
        } else if ((this.props.slotsFunction.provider === 'SCR' || this.props.slotsFunction.provider === 'SCR2') && !this.props.slotsFunction.isLoading) {
            this.props.history.push('/918kiss');
        } else if (this.props.slotsFunction.provider === 'MEGA' && !this.props.slotsFunction.isLoading) {
            this.props.history.push('/mega888');
        } else if (this.props.slotsFunction.provider === 'PSY8' && !this.props.slotsFunction.isLoading) {
            this.props.history.push('/psy8');
        }
    }

    render() {
        const { displaySubmenu, brand } = this.props.slotsFunction;
        const { portal, screen } = this.props;

        let maintenanceImg = '';

        if (portal.settings && portal.settings.maintenanceTranslationImg) {
            if (portal.settings.maintenanceTranslationImg && portal.settings.maintenanceTranslationImg[screen.viewType][this.props.language.key]) {
                maintenanceImg = portal.settings.maintenanceTranslationImg[screen.viewType][this.props.language.key];
            } else if (portal.settings.maintenanceTranslationImg.maintenanceIcon && portal.settings.maintenanceTranslationImg[screen.viewType]['all']) {
                maintenanceImg = portal.settings.maintenanceTranslationImg[screen.viewType].all;
            }
        }

        let maintenanceModalProps = {
            providerName: this.state.providerName,
            handleClose: this.handleClose,
            maintenanceDetails: this.state.maintenanceDetails,
        };

        return (
            <Translation>
                {(t) => (
                    <div className='brand-list'>
                        <ul>
                            {displaySubmenu.map((item, index) => (
                                <li
                                    key={item.provider}
                                    className={classnames('bg-gray', {
                                        on: brand === item.provider,
                                        badge: item.isHotProvider || item.isNewProvider,
                                        'badge-hot': item.isHotProvider,
                                        'badge-new': item.isNewProvider,
                                    })}
                                    onClick={this.handle.bind(this, item)}
                                >
                                    <span className='logo-box'>
                                        <div className={'icon-box'}>
                                            {/* <i className={"icon-" + item.provider}></i> */}
                                            <div className={`icon-${item.provider}`}>
                                                <SVG src={`/public/html/images/slot_img/icon-${item.provider}.svg`}>
                                                    {item.provider === 'PSY8' ? (
                                                        <img className='icon-PSY8' src='/public/html/images/slot_img/slot-psy8-icon.png' alt='psy8-icon' />
                                                    ) : (
                                                        <SVGElements
                                                            className={`icon-${item.provider}${['NS', 'PP'].includes(item.provider) ? '-slot' : ''}`}
                                                            name={'icon-' + item.provider}
                                                        />
                                                    )}
                                                </SVG>
                                            </div>
                                        </div>
                                    </span>
                                    <span className='logo-name'>{this.props.t(item.content)}</span>
                                    {item.underMaintenance && item.underMaintenance.gameMaintenance && (
                                        <div style={{ backgroundImage: `${maintenanceImg ? 'url(' + maintenanceImg + ')' : ''}` }} className='maintenance-hover-box'></div>
                                    )}
                                </li>
                            ))}

                            {/* Maintenance modal */}
                            {this.state.isUnderMaintenance && <MaintenanceModalV2 {...maintenanceModalProps}></MaintenanceModalV2>}
                        </ul>
                    </div>
                )}
            </Translation>
        );
    }
}

BrandList.propTypes = {
    slotsFunction: PropTypes.object.isRequired,
};

export default connect(mapStateToProps)(withTranslation(['providerName'])(withRouter(BrandList)));
